import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ElectricalGrid = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 23 22"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.352 4.18909L7.53655 11.6256L10.5517 11.5859L9.77888 17.171L14.5944 9.73446L11.5792 9.7741L12.352 4.18909Z"
      stroke="currentColor"
      strokeWidth="0.6089"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
